<template>
  <div :class="{ 'home': $route.name === 'ai_records', 'origin-bg': $route.name !== 'ai_records'}">
    <div class="banner py-4 mb-3 w-100" v-if="$route.name === 'ai_records'">
      <div class="container d-flex justify-content-between align-items-center flex-wrap">
        <div><img src="@/assets/image/ai/text_record.png" alt="" class=" object-contain"></div>
        <div class="row flex-nowrap">
          <router-link :to="{ 'name': 'AI_Home' }" class="col-4 col-md bg-white square d-flex align-items-center px-3 text-xl m-2 whitespace-pre-wrap">
            <img src="@/assets/image/ai/Arrow_right.png" alt="" class="object-contain rotate-180"><p class="text-dark mb-0">返回AI小幫手</p>
          </router-link>
        </div>
      </div>
    </div>
    <section class="w-100">
      <div class="container">
        <div class="p-2 p-xl-4">
          <!-- Table -->
          <Table v-if="tableList.datas && tableList.datas.length > 0"
            :columns="tableList.columns"
            :data="tableList.datas">
            <template v-slot:actionsLabel>
              <th class="text-center" :class="{ 'bg-white gray-text': $route.name === 'ai_records', 'origih-bg-th text-white': $route.name !== 'ai_records'}">序號</th>
              <th class="text-center" :class="{ 'bg-white gray-text': $route.name === 'ai_records', 'origih-bg-th text-white': $route.name !== 'ai_records'}">使用時間</th>
              <th class="text-center" :class="{ 'bg-white gray-text': $route.name === 'ai_records', 'origih-bg-th text-white': $route.name !== 'ai_records'}">項目</th>
              <th class="text-center" :class="{ 'bg-white gray-text': $route.name === 'ai_records', 'origih-bg-th text-white': $route.name !== 'ai_records'}">前往</th>
            </template>

            <template slot="actionsBtn" slot-scope="props">
              <td data-th="序號" class="text-left text-md-center blue-text">
                {{ props.item.index }}
              </td>
              <td data-th="使用時間" class="text-left text-md-center">
                <span class="">{{ moment(props.item.created_at).format('YYYY/MM/DD HH:mm:ss') }}</span>
              </td>
              <td data-th="項目" class="text-left text-md-center">
                <span class="">{{ props.item.name }}</span>
              </td>
              <td data-th="前往" class="text-left text-md-center">
                <a class="btn p-0 d-inline-block" @click="checkRecords(props.item)">
                  <img class="img-fluid" src="@/assets/image/ai/check_btn.png" alt="" style="width: 90px;" v-if="$route.name !== 'ai_records'">
                  <img class="img-fluid" src="@/assets/image/ai/btn_go.png" alt="" style="width: 90px;" v-if="$route.name === 'ai_records'">
                </a>
              </td>
            </template>
          </Table>
          <p v-else>尚無使用紀錄</p>

          <pagination class="m-auto pt-4" :current="pagination.currentPage" :total="pagination.length" v-on:page="toPage" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  // import moment from 'moment'
  import { mapGetters } from 'vuex'
  import Table from '@/components/AiHelper/table'
  import api from '@/store/api'
  import Pagination from '@/components/AiHelper/pagination.vue'
  export default {
    name: 'Records',
    metaInfo: {
      title: ''
    },
    components: {
      Table,
      Pagination
    },
    data () {
      return {
        serialno: null,
        password: null,
        tableList: {
          columns: [],
          datas: [
            {}
          ]
        },

        // pagination
        pagination: {
          currentPage: 1,
          length: 1
        },
        pageSize: 10
      }
    },
    computed: {
      ...mapGetters([
        'authorized',
        'remainPoints',
        'user'
      ])
    },
    watch: {
    },
    mounted () {
      this.getPointDeductionRecord()
    },
    methods: {
      async getPointDeductionRecord () {
        try {
          const path = `/usage_records?page=${this.pagination.currentPage}&pageSize=${this.pageSize}`
          const res = await api.get(path)
          this.tableList.datas = res.data.data
          this.pagination.length = res.data.total_pages
        } catch (error) {
          console.error('取得扣點紀錄失敗：', error)
        }
      },


      checkRecords (item) {
        let chatArr = ['AI_CHAT', 'AI_JAPANESE_SPEAKING_BEGINNER']
        let geptArr = ['AI_GEPT_SPEAKING_BEGINNER', 'AI_GEPT_WRITING_BEGINNER', 'AI_GEPT_SPEAKING_INTERMEDIATE', 'AI_GEPT_WRITING_INTERMEDIATE']
        let speechArr = ['AI_SPEECH', 'AI_LETTER', 'AI_JAPANESE_LETTER', 'AI_JAPANESE_SPEECH']
        let correctArr = ['AI_CORRECT']
        if (geptArr.includes(item.type)) {
          // GEPT
          this.$router.push({ name: 'gept_report_formal', params: { record_id: item.record_id } })
        } else if (chatArr.includes(item.type)) {
          // chat
          let lang = item.type === 'AI_CHAT' ? 'en' : 'jp'
          this.$router.push({ name: 'viewChat', params: { lang: lang }, query: { conversation_id: item.record_id } })
        } else if (speechArr.includes(item.type)) {
          let type = item.type === 'AI_SPEECH' || item.type === 'AI_JAPANESE_SPEECH' ? 'speech' : 'letter'
          this.$router.push({ name: 'viewGenerate', params: { aiType: type, promptId: item.record_id, generateType: 'generate' } })
        } else if (correctArr.includes(item.type)) {
          let type = item.type === 'AI_SPEECH' || item.type === 'AI_JAPANESE_SPEECH' ? 'speech' : 'letter'
          this.$router.push({ name: 'viewGenerate', params: { aiType: type, promptId: item.record_id, generateType: 'correct' } })
        }
      },

      toPage (toPage) {
        this.pagination.currentPage = toPage
        this.getPointDeductionRecord()
      },

      async checkSerialNumberAvailable() {
        if (!this.serialno || !this.password) return;

        // this.$store.dispatch('isLoading', true)

        try {
          const path = `/redeem`;
          const res = await api.post(path, { serialno: this.serialno, password: this.password });

          const redeemAmount = res.data.redeem_amount;
          const confirm = await this.showSwal({
            html: `
              <h4>確認兌換AI英語學習教室 ${redeemAmount}點?</h4>
              <p class="mb-2">目前總點數：<span style="color: #F30000;">${this.remainPoints}</span> 點</p>
              <p class="mb-2">增加 ${redeemAmount} 點</p>
              <p class="mb-2">增加後點數 <span style="color: #F30000;">${this.remainPoints + redeemAmount}</span> 點</p>
            `,
            confirmButtonText: `確認`,
            denyButtonText: `取消`
          });

          if (confirm.isConfirmed) {
            await this.redeemSerialNumber();
          }
        } catch (err) {
          this.showSwal({
            html: `<h4>${err.response?.data?.error || '發生錯誤'}</h4>`,
            confirmButtonText: `確認`
          });
        } finally {
          // this.$store.dispatch('isLoading', false);
        }
      },

      async redeemSerialNumber() {
        // this.$store.dispatch('isLoading', true);

        try {
          const path = `/redeem/${this.serialno}`;
          await api.post(path, { password: this.password });

          await this.$store.dispatch('getRemainPoints');
          this.showSwal({
            html: `<h4>兌換完成</h4>`,
            confirmButtonText: `確認`
          });
        } catch (err) {
          this.showSwal({
            html: `<h4>${err.response?.data?.msg || '兌換失敗'}</h4>`,
            confirmButtonText: `確認`
          });
        } finally {
          // this.$store.dispatch('isLoading', false);
        }
      },

      showSwal (options) {
        const defaultOptions = {
          showCloseButton: false,
          showDenyButton: true,
          focusConfirm: true,
          title: '兌換確認',
          denyButtonText: `取消`,
          customClass: {
            title: 'text-white',
            popup: 'p-0',
            header: 'swal-header-notice justify-center items-center',
            htmlContainer: 'save_check my-4',
            actions: 'mb-4 mt-2',
            confirmButton: 'btn-submit',
            denyButton: 'btn-deny order_1'
          }
        }
        return this.$swal.fire({ ...defaultOptions, ...options })
      }
    }
  }
</script>
<style lang="scss" scoped>
.page-item .page-link {
    color: black !important;
    font-weight: 800;
    border-width: 3px;
}
.blue-text {
  color: rgba(94, 160, 221, 1);
}
.gray-text {
  color: rgba(102, 102, 102, 1);
}
.green-text {
  color: rgba(25, 100, 46, 1);
}
section {
  // background-color: #EAEDF2;
  min-height: 100vh;
}
.origin-bg {
  background-color: #EAEDF2;
}
.origih-bg-th {
  background-color: rgba(90, 93, 155, 1);
}
.banner-text {
  left: 50%;
  top: 50%;
}
.inc_green {
  color: #19642E;
}
.home {
  background-color: #FAF5EF;
  min-height: 100vh;
}
.banner {
  min-height: 200px;
	background-image:
		url('~@/assets/image/ai/bg.png');
	background-repeat: repeat;
	background-position: center;
}
.square {
  min-height: 140px;
  border-radius: 20px;
  white-space: nowrap;
  .points {
    border-bottom: 1px solid rgba(115, 44, 178, 1);
  }
}

.text-purple-class {
  color: rgba(115, 44, 178, 1);
}
a {
  &:hover {
    text-decoration: none !important;
  }
}
.button_item {
  border: 1px solid rgba(94, 160, 221, 1);
  border-radius: 8px;
}
.rotate-180 {
  display: inline-block;     /* transform 對 inline 元素沒作用，改成 inline-block 或 block */
  transform: rotate(180deg);
  transform-origin: center;  /* 設定旋轉中心，可改成 left/right/top/bottom 或百分比 */
}
</style>
